import { Component } from '@angular/core';
import { CustomButtons } from '../../../classes/commons/custom-buttons';

@Component({
  selector: 'app-remove-button',
  templateUrl: './remove-button.component.html',
  styleUrls: ['./remove-button.component.scss'],
})
export class RemoveButtonComponent extends CustomButtons {}
